import React, { useState } from 'react';

const Reglements: React.FC = () => {
  const [activeSection, setActiveSection] = useState('principes');

  const sections = [
    { id: 'principes', label: 'Principes Généraux', icon: '⚖️' },
    { id: 'cours', label: 'Cours', icon: '📚' },
    { id: 'tp', label: 'Travaux Pratiques', icon: '🔬' },
    { id: 'stages', label: 'Stages', icon: '🏥' },
    { id: 'autres', label: 'Autres Règles', icon: '📋' }
  ];

  return (
    <section id="reglements" className="py-16 bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* En-tête */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Règlements de l'Institut
          </h2>
          <div className="w-24 h-1 bg-red-600 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Règles et obligations à respecter scrupuleusement par tous les étudiants de l'ISTMECH
          </p>
        </div>

        {/* Navigation */}
        <div className="flex flex-wrap justify-center mb-8 bg-white dark:bg-gray-800 rounded-xl p-2 shadow-lg transition-colors duration-200">
          {sections.map((section) => (
            <button
              key={section.id}
              onClick={() => setActiveSection(section.id)}
              className={`flex items-center px-4 py-3 m-1 rounded-lg font-medium transition-all duration-200 ${
                activeSection === section.id
                  ? 'bg-red-600 text-white shadow-lg'
                  : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-red-600 dark:hover:text-red-400'
              }`}
            >
              <span className="mr-2">{section.icon}</span>
              <span className="hidden sm:inline">{section.label}</span>
            </button>
          ))}
        </div>

        {/* Contenu */}
        <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-lg transition-colors duration-200">
          {/* PRINCIPES GÉNÉRAUX */}
          {activeSection === 'principes' && (
            <div className="space-y-8">
              <div className="text-center mb-8">
                <h3 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
                  Principes Généraux
                </h3>
                <p className="text-lg text-gray-600 dark:text-gray-300">
                  Fondements et valeurs de l'ISTMECH
                </p>
              </div>

              {/* Institution non confessionnelle */}
              <div className="bg-blue-50 dark:bg-blue-900/20 border-l-4 border-blue-500 dark:border-blue-400 p-6 rounded-r-lg">
                <h4 className="text-xl font-bold text-blue-900 dark:text-blue-100 mb-4 flex items-center">
                  <span className="mr-3">🤝</span>
                  Institution Non Confessionnelle
                </h4>
                <p className="text-blue-800 dark:text-blue-200 leading-relaxed">
                  L'Institut Supérieur de Technologie Médicale du Cap-Haïtien est une <strong>Institution non Confessionnelle</strong>. 
                  Tout individu ayant satisfait aux conditions d'admission a sa place à l'Institut.
                </p>
              </div>

              {/* Non-discrimination */}
              <div className="bg-green-50 dark:bg-green-900/20 border-l-4 border-green-500 dark:border-green-400 p-6 rounded-r-lg">
                <h4 className="text-xl font-bold text-green-900 dark:text-green-100 mb-4 flex items-center">
                  <span className="mr-3">🌍</span>
                  Égalité et Non-Discrimination
                </h4>
                <p className="text-green-800 dark:text-green-200 leading-relaxed mb-4">
                  Il ne sera fait <strong>aucun cas</strong> de l'appartenance sociale, politique ou religieuse de l'étudiant.
                </p>
                <div className="bg-green-100 dark:bg-green-800/30 rounded-lg p-4">
                  <p className="text-green-900 dark:text-green-100 font-medium">
                    ✅ Tous les étudiants sont traités sur un pied d'égalité, indépendamment de leur origine
                  </p>
                </div>
              </div>

              {/* Respect des règlements */}
              <div className="bg-red-50 dark:bg-red-900/20 border-l-4 border-red-500 dark:border-red-400 p-6 rounded-r-lg">
                <h4 className="text-xl font-bold text-red-900 dark:text-red-100 mb-4 flex items-center">
                  <span className="mr-3">⚠️</span>
                  Respect Scrupuleux des Règlements
                </h4>
                <p className="text-red-800 dark:text-red-200 leading-relaxed mb-4">
                  Toutefois, tout individu admis à l'Institut doit <strong>respecter scrupuleusement</strong> 
                  les règlements de l'Institution.
                </p>
                <div className="bg-red-100 dark:bg-red-800/30 rounded-lg p-4">
                  <p className="text-red-900 dark:text-red-100 font-bold">
                    🚫 AUCUNE DÉROGATION ne sera accordée pour des questions sociales, politiques ou religieuses
                  </p>
                </div>
              </div>

              {/* Uniforme obligatoire */}
              <div className="bg-purple-50 dark:bg-purple-900/20 border-l-4 border-purple-500 dark:border-purple-400 p-6 rounded-r-lg">
                <h4 className="text-xl font-bold text-purple-900 dark:text-purple-100 mb-4 flex items-center">
                  <span className="mr-3">👔</span>
                  Port de l'Uniforme
                </h4>
                <p className="text-purple-800 dark:text-purple-200 leading-relaxed">
                  L'étudiant est astreint à participer à toutes les activités de l'Institut <strong>EN UNIFORME</strong>, 
                  quel que soit le jour, l'heure et l'endroit, pour peu que toutes les conditions de normalité soient assurées.
                </p>
              </div>

              {/* Religion d'État */}
              <div className="bg-yellow-50 dark:bg-yellow-900/20 border-l-4 border-yellow-500 dark:border-yellow-400 p-6 rounded-r-lg">
                <h4 className="text-xl font-bold text-yellow-900 dark:text-yellow-100 mb-4 flex items-center">
                  <span className="mr-3">⛪</span>
                  Cérémonies Officielles
                </h4>
                <p className="text-yellow-800 dark:text-yellow-200 leading-relaxed">
                  Étant une Institution de l'État, l'Institut a adopté pour les cérémonies officielles 
                  la <strong>Religion Catholique</strong> qui est la Religion d'État en Haïti.
                </p>
              </div>
            </div>
          )}

          {/* COURS */}
          {activeSection === 'cours' && (
            <div className="space-y-8">
              <div className="text-center mb-8">
                <h3 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
                  Règlement des Cours
                </h3>
                <p className="text-lg text-gray-600 dark:text-gray-300">
                  Présence obligatoire et gestion des absences
                </p>
              </div>

              {/* Présence obligatoire */}
              <div className="bg-blue-50 dark:bg-blue-900/20 rounded-xl p-6">
                <h4 className="text-xl font-bold text-blue-900 dark:text-blue-100 mb-4 flex items-center">
                  <span className="mr-3">✅</span>
                  Présence Obligatoire
                </h4>
                <p className="text-blue-800 dark:text-blue-200 text-lg mb-4">
                  L'étudiant doit être présent à <strong>tous les cours</strong> dispensés à l'Institut.
                </p>
                <div className="bg-blue-100 dark:bg-blue-800/30 rounded-lg p-4">
                  <p className="text-blue-900 dark:text-blue-100 font-medium">
                    📊 Les absences et les retards seront comptabilisés
                  </p>
                </div>
              </div>

              {/* Règles d'absence */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-orange-50 dark:bg-orange-900/20 border-l-4 border-orange-500 dark:border-orange-400 p-6 rounded-r-lg">
                  <h5 className="text-lg font-bold text-orange-900 dark:text-orange-100 mb-3 flex items-center">
                    <span className="mr-2">⏰</span>
                    Retards
                  </h5>
                  <div className="bg-orange-100 dark:bg-orange-800/30 rounded-lg p-4 text-center">
                    <div className="text-2xl font-bold text-orange-900 dark:text-orange-100 mb-1">3</div>
                    <div className="text-orange-800 dark:text-orange-200 text-sm">retards = 1 absence</div>
                  </div>
                </div>

                <div className="bg-red-50 dark:bg-red-900/20 border-l-4 border-red-500 dark:border-red-400 p-6 rounded-r-lg">
                  <h5 className="text-lg font-bold text-red-900 dark:text-red-100 mb-3 flex items-center">
                    <span className="mr-2">🚫</span>
                    Abandon
                  </h5>
                  <div className="bg-red-100 dark:bg-red-800/30 rounded-lg p-4">
                    <p className="text-red-900 dark:text-red-100 text-sm font-medium">
                      Absences répétées ou pendant <strong>1 mois consécutif</strong> = Abandon
                    </p>
                  </div>
                </div>
              </div>

              {/* Sanctions */}
              <div className="bg-red-50 dark:bg-red-900/20 rounded-xl p-6">
                <h4 className="text-xl font-bold text-red-900 dark:text-red-100 mb-4 flex items-center">
                  <span className="mr-3">⚖️</span>
                  Sanctions
                </h4>
                <div className="bg-red-100 dark:bg-red-800/30 rounded-lg p-4">
                  <p className="text-red-900 dark:text-red-100 font-bold text-center">
                    La Direction décidera du sort de l'étudiant coupable.<br/>
                    <span className="text-lg">La sanction peut aller jusqu'au RENVOI</span>
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* TRAVAUX PRATIQUES */}
          {activeSection === 'tp' && (
            <div className="space-y-8">
              <div className="text-center mb-8">
                <h3 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
                  Travaux Pratiques
                </h3>
                <p className="text-lg text-gray-600 dark:text-gray-300">
                  Règles strictes pour les séances de TP
                </p>
              </div>

              {/* Caractère obligatoire */}
              <div className="bg-purple-50 dark:bg-purple-900/20 rounded-xl p-6">
                <h4 className="text-xl font-bold text-purple-900 dark:text-purple-100 mb-4 flex items-center">
                  <span className="mr-3">🔬</span>
                  Caractère Obligatoire
                </h4>
                <p className="text-purple-800 dark:text-purple-200 text-lg mb-4">
                  Les Travaux Pratiques sont <strong>OBLIGATOIRES</strong>. La présence, la participation 
                  et l'application de l'étudiant aux Travaux Pratiques sont <strong>indispensables</strong>.
                </p>
              </div>

              {/* Règle des 4 absences */}
              <div className="bg-red-50 dark:bg-red-900/20 border-l-4 border-red-500 dark:border-red-400 p-6 rounded-r-lg">
                <h4 className="text-xl font-bold text-red-900 dark:text-red-100 mb-4 flex items-center">
                  <span className="mr-3">📊</span>
                  Limite d'Absences
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-red-100 dark:bg-red-800/30 rounded-lg p-4 text-center">
                    <div className="text-3xl font-bold text-red-900 dark:text-red-100 mb-2">4+</div>
                    <div className="text-red-800 dark:text-red-200 font-medium">absences aux TP</div>
                    <div className="text-red-700 dark:text-red-300 text-sm mt-2">= Refaire l'année d'office</div>
                  </div>
                  <div className="bg-red-200 dark:bg-red-800/40 rounded-lg p-4">
                    <h5 className="font-bold text-red-900 dark:text-red-100 mb-2">Si absent aux cours aussi :</h5>
                    <ul className="text-red-800 dark:text-red-200 text-sm space-y-1">
                      <li>• Considéré comme abandon</li>
                      <li>• Reprise d'année ou renvoi</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Règle spéciale 1ère année */}
              <div className="bg-yellow-50 dark:bg-yellow-900/20 border-l-4 border-yellow-500 dark:border-yellow-400 p-6 rounded-r-lg">
                <h4 className="text-xl font-bold text-yellow-900 dark:text-yellow-100 mb-4 flex items-center">
                  <span className="mr-3">⚠️</span>
                  Règle Spéciale - Première Année
                </h4>
                <div className="bg-yellow-100 dark:bg-yellow-800/30 rounded-lg p-4">
                  <p className="text-yellow-900 dark:text-yellow-100 font-bold text-center">
                    🚫 L'étudiant de Première Année ne pourra reprendre l'année en aucun cas.<br/>
                    <span className="text-lg">Il sera RENVOYÉ DÉFINITIVEMENT</span>
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* STAGES */}
          {activeSection === 'stages' && (
            <div className="space-y-8">
              <div className="text-center mb-8">
                <h3 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
                  Règlement des Stages
                </h3>
                <p className="text-lg text-gray-600 dark:text-gray-300">
                  Règles strictes et incontournables pour les stages
                </p>
              </div>

              {/* Caractéristiques des stages */}
              <div className="bg-gradient-to-r from-blue-50 to-purple-50 dark:from-gray-700 dark:to-gray-600 rounded-xl p-6">
                <h4 className="text-xl font-bold text-gray-900 dark:text-white mb-6 text-center">
                  Les Stages sont : OBLIGATOIRES • PARTICIPATIFS • INCONTOURNABLES
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-white dark:bg-gray-700 rounded-lg p-4 text-center">
                    <div className="text-2xl font-bold text-blue-600 mb-2">7/7</div>
                    <div className="text-gray-700 dark:text-gray-300">jours par semaine</div>
                    <div className="text-gray-600 dark:text-gray-400 text-sm">(Samedi et Dimanche compris)</div>
                  </div>
                  <div className="bg-white dark:bg-gray-700 rounded-lg p-4 text-center">
                    <div className="text-2xl font-bold text-purple-600 mb-2">24/24</div>
                    <div className="text-gray-700 dark:text-gray-300">heures par jour</div>
                    <div className="text-gray-600 dark:text-gray-400 text-sm">(Suivant roulement établi)</div>
                  </div>
                </div>
              </div>

              {/* Stages extra muros */}
              <div className="bg-green-50 dark:bg-green-900/20 border-l-4 border-green-500 dark:border-green-400 p-6 rounded-r-lg">
                <h4 className="text-lg font-bold text-green-900 dark:text-green-100 mb-3 flex items-center">
                  <span className="mr-2">🏥</span>
                  Stages Extra Muros
                </h4>
                <ul className="text-green-800 dark:text-green-200 space-y-2">
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-green-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                    Suivre l'horaire de l'établissement d'affectation en semaine
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-green-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                    Dispensés du service de garde d'urgence
                  </li>
                </ul>
              </div>

              {/* Interdictions strictes */}
              <div className="space-y-4">
                <h4 className="text-xl font-bold text-red-900 dark:text-red-100 mb-4 flex items-center">
                  <span className="mr-3">🚫</span>
                  Interdictions Strictes
                </h4>
                
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-700 rounded-lg p-4">
                    <div className="text-center mb-3">
                      <span className="text-2xl">🚫</span>
                    </div>
                    <h5 className="font-bold text-red-900 dark:text-red-100 mb-2 text-center">A. Abandon</h5>
                    <p className="text-red-800 dark:text-red-200 text-sm text-center">
                      Aucun stagiaire n'est autorisé à abandonner ses stages, 
                      <strong> ne serait-ce qu'une minute</strong>
                    </p>
                  </div>

                  <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-700 rounded-lg p-4">
                    <div className="text-center mb-3">
                      <span className="text-2xl">🔄</span>
                    </div>
                    <h5 className="font-bold text-red-900 dark:text-red-100 mb-2 text-center">B. Échange</h5>
                    <p className="text-red-800 dark:text-red-200 text-sm text-center">
                      Aucun stagiaire n'est autorisé à <strong>changer de jour</strong> 
                      de stage avec un autre stagiaire
                    </p>
                  </div>

                  <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-700 rounded-lg p-4">
                    <div className="text-center mb-3">
                      <span className="text-2xl">↔️</span>
                    </div>
                    <h5 className="font-bold text-red-900 dark:text-red-100 mb-2 text-center">C. Section</h5>
                    <p className="text-red-800 dark:text-red-200 text-sm text-center">
                      Aucun stagiaire n'est autorisé à <strong>changer de section</strong> 
                      sans autorisation des Moniteurs et du Superviseur
                    </p>
                  </div>
                </div>
              </div>

              {/* Sanctions stages */}
              <div className="bg-red-100 dark:bg-red-800/30 rounded-xl p-6">
                <h4 className="text-xl font-bold text-red-900 dark:text-red-100 mb-4 text-center flex items-center justify-center">
                  <span className="mr-3">⚖️</span>
                  Sanctions pour Manquements
                </h4>
                <div className="bg-red-200 dark:bg-red-800/40 rounded-lg p-4">
                  <p className="text-red-900 dark:text-red-100 font-bold text-center">
                    Tout manquement sera puni <strong>SÉVÈREMENT</strong><br/>
                    <span className="text-lg">Du BLÂME avec remise des jours manqués jusqu'au RENVOI</span>
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* AUTRES RÈGLES */}
          {activeSection === 'autres' && (
            <div className="space-y-8">
              <div className="text-center mb-8">
                <h3 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
                  Autres Règles Importantes
                </h3>
                <p className="text-lg text-gray-600 dark:text-gray-300">
                  Règles complémentaires et dispositions diverses
                </p>
              </div>

              {/* Participation aux activités */}
              <div className="bg-blue-50 dark:bg-blue-900/20 rounded-xl p-6">
                <h4 className="text-xl font-bold text-blue-900 dark:text-blue-100 mb-4 flex items-center">
                  <span className="mr-3">🎯</span>
                  Participation aux Activités
                </h4>
                <p className="text-blue-800 dark:text-blue-200 mb-4">
                  L'étudiant participe <strong>obligatoirement</strong> à toutes les activités de l'Institut 
                  pour lesquelles sa présence est requise.
                </p>
                
                <div className="bg-blue-100 dark:bg-blue-800/30 rounded-lg p-4">
                  <h5 className="font-bold text-blue-900 dark:text-blue-100 mb-2">En cas de maladie :</h5>
                  <ul className="text-blue-800 dark:text-blue-200 space-y-1">
                    <li>• Certificat médical obligatoire</li>
                    <li>• Délai maximum : <strong>48 heures</strong></li>
                    <li>• La Direction peut référer à un médecin de l'Institut</li>
                  </ul>
                </div>
              </div>

              {/* Téléphones portables */}
              <div className="bg-orange-50 dark:bg-orange-900/20 rounded-xl p-6">
                <h4 className="text-xl font-bold text-orange-900 dark:text-orange-100 mb-4 flex items-center">
                  <span className="mr-3">📱</span>
                  Interdiction des Téléphones Portables
                </h4>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <h5 className="font-bold text-orange-900 dark:text-orange-100 mb-3">🚫 Interdits pendant les stages :</h5>
                    <ul className="text-orange-800 dark:text-orange-200 space-y-1 text-sm">
                      <li>• Salles de travail</li>
                      <li>• Couloirs</li>
                      <li>• Salle de prélèvement</li>
                      <li>• Accueil</li>
                    </ul>
                  </div>
                  
                  <div>
                    <h5 className="font-bold text-orange-900 dark:text-orange-100 mb-3">🚫 Interdits pendant :</h5>
                    <ul className="text-orange-800 dark:text-orange-200 space-y-1 text-sm">
                      <li>• Salles de cours</li>
                      <li>• Salles de TP</li>
                      <li>• Exposés</li>
                      <li>• Toute activité de l'Institut</li>
                    </ul>
                  </div>
                </div>
                
                <div className="bg-orange-100 dark:bg-orange-800/30 rounded-lg p-4 mt-4">
                  <p className="text-orange-900 dark:text-orange-100 font-bold text-center">
                    ⚠️ Sanction : Confiscation pour un temps indéterminé
                  </p>
                </div>
              </div>

              {/* Éthique et déontologie */}
              <div className="bg-purple-50 dark:bg-purple-900/20 rounded-xl p-6">
                <h4 className="text-xl font-bold text-purple-900 dark:text-purple-100 mb-4 flex items-center">
                  <span className="mr-3">⚖️</span>
                  Éthique et Déontologie
                </h4>
                <div className="bg-purple-100 dark:bg-purple-800/30 rounded-lg p-4">
                  <p className="text-purple-900 dark:text-purple-100 font-bold text-center text-lg">
                    Tout manquement à l'éthique et à la déontologie sera sanctionné <strong>SÉVÈREMENT</strong>
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Avertissement général */}
        <div className="mt-8 bg-gradient-to-r from-red-500 to-red-600 text-white rounded-xl p-6 text-center">
          <h3 className="text-2xl font-bold mb-4">⚠️ AVERTISSEMENT GÉNÉRAL</h3>
          <p className="text-lg">
            Tous les règlements de l'ISTMECH doivent être respectés scrupuleusement. 
            Le non-respect peut entraîner des sanctions allant du blâme au renvoi définitif.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Reglements;
